import { render, staticRenderFns } from "./GroupCopy.vue?vue&type=template&id=edd4cc60&"
import script from "./GroupCopy.vue?vue&type=script&lang=js&"
export * from "./GroupCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports